
































































































import { Component, Vue } from "vue-property-decorator";
import PrismEditor from "vue-prism-editor";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-markup-templating.js";
import "prismjs/components/prism-php.js";
import NewFieldForm from "@/components/generator/NewFieldForm.vue";
import EditFieldForm from "@/components/generator/EditFieldForm.vue";
import { TableField, TableOperation } from "@/interfaces/generator";

@Component({
  components: {
    PrismEditor,
    NewFieldForm,
    EditFieldForm
  }
})
export default class Generator extends Vue {
  tableName = "";
  tableOperation: TableOperation = "create";
  tableNewName = "";

  fields: TableField[] = [];

  newField: TableField = {
    id: Math.random(),
    type: "",
    name: "",
    editMode: false,
    nullable: false,
    unsigned: false,
    autoIncrement: false
  };

  private get code() {
    if (this.tableOperation == "drop") {
      return `
    <?php

    use Illuminate\\Support\\Facades\\Schema;
    use Illuminate\\Database\\Schema\\Blueprint;
    use Illuminate\\Database\\Migrations\\Migration;

    class ${this.tableOperation.charAt(0).toUpperCase() +
      this.tableOperation.slice(1)}${this.tableName.charAt(0).toUpperCase() +
        this.tableName.slice(1)}Table extends Migration
    {
        /**
         * Run the migrations.
         *
         * @return void
         */
        public function up()
        {
            Schema::drop('${this.tableName}');
        }

        /**
         * Reverse the migrations.
         *
         * @return void
         */
        public function down()
        {
            Schema::create('${this.tableName.toLowerCase().trim()}');
        }
    }
    `;
    } else if (this.tableOperation == "rename") {
      return `
    <?php

    use Illuminate\\Support\\Facades\\Schema;
    use Illuminate\\Database\\Schema\\Blueprint;
    use Illuminate\\Database\\Migrations\\Migration;

    class ${this.tableOperation.charAt(0).toUpperCase() +
      this.tableOperation.slice(1)}${this.tableName.charAt(0).toUpperCase() +
        this.tableName.slice(1)}Table extends Migration
    {
        /**
         * Run the migrations.
         *
         * @return void
         */
        public function up()
        {
            Schema::rename('${this.tableName
              .toLowerCase()
              .trim()}', '${this.tableNewName.toLowerCase().trim()}');
        }

        /**
         * Reverse the migrations.
         *
         * @return void
         */
        public function down()
        {
            Schema::rename('${this.tableNewName
              .toLowerCase()
              .trim()}', '${this.tableName.toLowerCase().trim()}');
        }
    }
    `;
    } else if (this.tableOperation == "modify") {
      return `
    <?php

    use Illuminate\\Support\\Facades\\Schema;
    use Illuminate\\Database\\Schema\\Blueprint;
    use Illuminate\\Database\\Migrations\\Migration;

    class ${this.tableOperation.charAt(0).toUpperCase() +
      this.tableOperation.slice(1)}${this.tableName.charAt(0).toUpperCase() +
        this.tableName.slice(1)}Table extends Migration
    {
        /**
         * Run the migrations.
         *
         * @return void
         */
        public function up()
        {
            Schema::${"table"}('${this.tableName
        .toLowerCase()
        .trim()}', function (Blueprint $table) {
                ${this.fieldsString}
            });
        }

        /**
         * Reverse the migrations.
         *
         * @return void
         */
        public function down()
        {
            Schema::${"table"}('${this.tableName
        .toLowerCase()
        .trim()}', function (Blueprint $table) {
                ${this.dropFieldsString}
            });
        }
    }
    `;
    } else {
      return `
    <?php

    use Illuminate\\Support\\Facades\\Schema;
    use Illuminate\\Database\\Schema\\Blueprint;
    use Illuminate\\Database\\Migrations\\Migration;

    class ${this.tableOperation.charAt(0).toUpperCase() +
      this.tableOperation.slice(1)}${this.tableName.charAt(0).toUpperCase() +
        this.tableName.slice(1)}Table extends Migration
    {
        /**
         * Run the migrations.
         *
         * @return void
         */
        public function up()
        {
            Schema::${"create"}('${this.tableName
        .toLowerCase()
        .trim()}', function (Blueprint $table) {
                ${this.fieldsString}
            });
        }

        /**
         * Reverse the migrations.
         *
         * @return void
         */
        public function down()
        {
            Schema::drop('${this.tableName.toLowerCase().trim()}');
        }
    }
    `;
    }
  }

  private get fieldsString() {
    let fieldsString = "";

    if (!this.fields.length) {
      return `// Please add your fields`;
    }

    for (const [index, field] of this.fields.entries()) {
      let indent = "";
      let newLine = "\n";
      const unsigned = field.unsigned ? "->unsigned()" : "";
      const nullable = field.nullable ? "->nullable()" : "";
      const autoIncrement = field.autoIncrement ? "->autoIncrement()" : "";

      if (index > 0) {
        indent = "                ";
      }

      if (index === this.fields.length - 1) {
        newLine = "";
      }

      fieldsString =
        fieldsString +
        indent +
        `$table->${field.type}('${field.name}')${nullable}${unsigned}${autoIncrement};` +
        newLine;
    }

    return fieldsString;
  }

  private get dropFieldsString() {
    let fieldsString = "";

    if (!this.fields.length) {
      return `// Please add your fields`;
    }

    for (const [index, field] of this.fields.entries()) {
      let indent = "";
      let newLine = "\n";

      if (index > 0) {
        indent = "                ";
      }

      if (index === this.fields.length - 1) {
        newLine = "";
      }

      fieldsString =
        fieldsString +
        indent +
        `$table->dropColumn('${field.name}');` +
        newLine;
    }

    return fieldsString;
  }

  private addField() {
    this.fields.push(this.newField);
    this.newField = {
      id: Math.random(),
      type: "",
      name: "",
      editMode: false,
      nullable: false,
      unsigned: false,
      autoIncrement: false
    };
  }

  private removeField(fieldIndex: number) {
    this.fields.splice(fieldIndex, 1);
  }

  private clipboardSuccessHandler() {
    this.$buefy.snackbar.open({
      message: "Code was succesfully pasted to clipboard",
      type: "is-white"
    });
  }
}
